import {
    pureWhite,
    lightMarineColor,
    azurColor,
    lightMarineColorShade,
} from '@ui/styles/colors';

export const chatAnswerWrapperStyle = {
    padding         : 0,
    marginBottom    : 16,
    transition      : '.5s all ease',
    transformOrigin : 'top right',
    alignItems      : 'flex-start',
};

export const chatAnswerTextWrapperStyle = {
    display                 : 'inline-flex',
    flexGrow                : 0,
    alignItems              : 'center',
    paddingTop              : 4,
    paddingBottom           : 4,
    paddingRight            : 4,
    paddingLeft             : 4,
    background              : lightMarineColor,
    borderTopLeftRadius     : 19,
    borderTopRightRadius    : 0,
    borderBottomLeftRadius  : 19,
    borderBottomRightRadius : 19,
    color                   : pureWhite,
    marginTop               : 0,
    cursor                  : 'pointer',
};

export const chatAnswerNameStyle = {
    lineHeight   : 0.9,
    color        : lightMarineColorShade,
    display      : 'block',
    marginBottom : 3,
};

export const chatAnswerTextWrapperWithImageStyle = {
    ...chatAnswerTextWrapperStyle,
    borderTopLeftRadius     : 19,
    borderTopRightRadius    : 19,
    borderBottomLeftRadius  : 19,
    borderBottomRightRadius : 0,
    marginTop               : 0,
};

export const chatAnswerAvatarStyle = {
    width                : '100%',
    maxWidth             : 300,
    boxSizing            : 'border-box' as 'border-box',
    height               : 140,
    objectFit            : 'cover' as 'cover',
    objectPosition       : '50% 50%',
    borderRadius         : 19,
    borderTopRightRadius : 0,
    marginTop            : 4,
    backgroundColor      : pureWhite,
    cursor               : 'pointer',
};

export const chatAnswerListItemTextPrimaryStyle = {
    display       : 'flex',
    flexDirection : 'column' as 'column',
    alignItems    : 'flex-end' as 'flex-end',
};

export const chatAnswerChildrenWrapperStyle = {
    paddingTop    : 4,
    paddingBottom : 4,
    paddingLeft   : 16,
    paddingRight  : 16,
};

export const chatAnswerListItemTextStyle = {
    display       : 'flex',
    flexDirection : 'column' as 'column',
    alignItems    : 'flex-end',
    margin        : 0,
    paddingLeft   : 46,
    marginTop     : 0,
    lineHeight    : 1,
};

export const chatAnswerListItemAvatarStyle = {
    display       : 'flex',
    flexDirection : 'row-reverse' as 'row-reverse',
    alignSelf     : 'flex-start',
    minWidth      : 46,
};

export const chatAnswerDeleteButtonStyle = {
    alignSelf       : 'flex-start',
    color           : pureWhite,
    backgroundColor : azurColor,
    marginRight     : 1,
    marginTop       : 1,
    width           : 28,
    height          : 28,
};

export const chatAnswerEditIconStyle = {
    fontSize    : 12,
    marginTop   : -7,
    marginRight : -1,
};
